import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Spaces_poster from '../../../Assets/Images/ProjectsImg/TrainingCertificateCourses/Spaces.jpeg'

import Spaces_1 from '../../../Assets/Images/Training/Certificate cources/Spaces/Spaces_1.jpg';
import Spaces_2 from '../../../Assets/Images/Training/Certificate cources/Spaces/Spaces_2.jpg';
import Spaces_3 from '../../../Assets/Images/Training/Certificate cources/Spaces/Spaces_3.jpg';
import Spaces_4 from '../../../Assets/Images/Training/Certificate cources/Spaces/Spaces_4.jpg';

import SPACES_Note from '../../../Assets/Images/Training/Certificate cources/Spaces/SPACES_Note.pdf';
import SPACES_Schedule from '../../../Assets/Images/Training/Certificate cources/Spaces/SPACES_Schedule.pdf';

const Spaces = () => {

    return (
        <div className="mt-5">
            <h4>Sustainable Practices and Advancement in Comfort Enhancement System</h4>

            <div className="card mt-5">
                <img
                    src={Spaces_poster}
                    className="card-img-top"
                    alt="Poster"
                />
            </div>

            <div className="mt-5">
                <p>The aim of the training program is to equip participants with a comprehensive understanding of the theories, principles, and cutting-edge practices of sustainability, as adopted by leading national and international institutions. Through expert-led sessions and case studies, participants will gain valuable insights into innovative and context-specific approaches to sustainable development. The program emphasizes an integrated approach to the built environment, encouraging holistic thinking that combines ecological responsibility with user comfort. By the end of the training, participants will have enhanced their skills and knowledge to effectively implement sustainable strategies and comfort enhancement systems in their professional domains</p>
            </div>

            <div className="row mb-4 mt-5">
                <div className="col-md-4 mb-3">
                    <div className="card">
                        <img src={Spaces_1} className="card-img-top" alt="Event" />
                    </div>
                </div>
                <div className="col-md-4 mb-3">
                    <div className="card">
                        <img src={Spaces_2} className="card-img-top" alt="Event" />
                    </div>
                </div>
                <div className="col-md-4 mb-3">
                    <div className="card">
                        <img src={Spaces_3} className="card-img-top" alt="Event" />
                    </div>
                </div>
                <div className="col-md-4 mb-3">
                    <div className="card">
                        <img src={Spaces_4} className="card-img-top" alt="Event" />
                    </div>
                </div>
            </div>

            <div className="mb-4">
                <p><strong>Concept Note: </strong>
                    <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => {
                            window.open(SPACES_Note, '_blank');
                        }}
                    >
                        Open PDF
                    </button>
                </p>
                <p><strong>Programme Schedule: </strong>
                    <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => {
                            window.open(SPACES_Schedule, '_blank');
                        }}
                    >
                        Open PDF
                    </button>
                </p>
            </div>

            <div>
                <p><strong>Timeline:</strong> 21st October 2024 - 25th October 2024</p>
                <p><strong>Status:</strong> Completed</p>
            </div>
        </div>
    );
};

export default Spaces;

